<template>
    <div class="index-container">
        <Header></Header>

        <div v-if="activeSlider == 'team-manage'" class="page-container">
            <div class="page-back-container">
                <div class="page-back-wrapper">
                    <div class="page-back" @click="handleBack">
                        <img src="@/assets/img/back.png" alt="" class="page-back-img">
                        <span>返回</span>
                    </div>
                </div>
            </div>
            <div style="margin-top:18px;">
                <TeamManage></TeamManage>
            </div>
        </div>
        <div v-else class="page-container">

            <div v-if="courseStatus != 'course-add' && courseStatus != 'course-edit'" class="page-wrapper">
                <div class="slider-container">
                    <Slider :sliderVal="activeSlider" @sliderVal="getSlider"></Slider>
                </div>
                <div :class="activeSlider == 'team-manage' ? 'page-manage-content' : 'page-content'">
                    <div v-if="activeSlider == 'enterprise-center'" class="page-content-item">
                        <EnterpriseCenter></EnterpriseCenter>
                    </div>
                    <div v-if="activeSlider == 'study-report-member' || activeSlider == 'study-report-course'"
                        class="page-content-item">
                        <StudyReport :modeVal="activeSlider"></StudyReport>
                    </div>
                    <div v-if="activeSlider == 'course-manage' && courseStatus == 'course-list'"
                        class="page-content-item">
                        <CourseManage @courseStatus="getCourseStatus" @courseRow="getCourseRow"></CourseManage>
                    </div>
                </div>
            </div>
            <div v-if="courseStatus == 'course-add'">
                <CourseForm @courseStatus="getCourseStatus"></CourseForm>
            </div>
            <div v-if="courseStatus == 'course-edit'">
                <CourseForm @courseStatus="getCourseStatus" :status="courseStatus" :row="courseRow"></CourseForm>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Slider from '@/components/Slider.vue'
import TreeModel from '@/components/TreeModel.vue'
import EnterpriseCenter from './EnterCenter/index.vue'
import StudyReport from './StudyReport/index.vue'
import TeamManage from './TeamManage/index.vue'
import CourseManage from './CourseManage/index.vue'
import CourseForm from './CourseManage/CourseForm.vue'
export default {
    name: '',
    components: {
        Header,
        Slider,
        TreeModel,
        EnterpriseCenter,
        StudyReport,
        TeamManage,
        CourseManage,
        CourseForm
    },
    data() {
        return {
            dept: '',
            token: '',
            activeSlider: "enterprise-center",
            courseStatus: "course-list",
            courseRow: ""
        }
    },
    created() {

        var id = this.$route.query.id;
        var dept = this.$route.query.topDeptId;
        var token = this.$route.query.token;

        if (id) {
            localStorage.setItem('id', id)
        }
        if (dept) {
            localStorage.setItem('dept', dept)
        }
        if (token) {
            localStorage.setItem('token', token.replace(/^"|"$/g, ''))

        }






        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        // var targetMode = this.$route.params.id;
        // this.activeSlider = targetMode;
        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;
        // var token = window.localStorage.getItem('token');
        // if (!token) {
        //     window.localStorage.setItem('token', this.token);
        // }
        // var dept = window.localStorage.getItem('dept');
        // if (!dept) {
        //     window.localStorage.setItem('dept', this.dept);
        // }
    },
    mounted() {

    },
    methods: {
        getSlider(target) {
            if (target == 'study-report') {
                this.activeSlider = 'study-report-member';
            } else {
                this.activeSlider = target;
            }
        },
        handleBack() {
            this.activeSlider = 'enterprise-center';
        },
        getCourseStatus(params) {
            this.courseStatus = params;
        },
        getCourseRow(params) {
            this.courseRow = params;
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 1200px;
    margin: 0 auto;
}



.page-wrapper {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    margin-top: 18px;
}

.page-back-container {
    position: fixed;
    top: 100px;
    width: 1200px;
    /* z-index:50; */
}

.page-back-wrapper {
    margin-top: 18px;
    width: 100%;
    height: 68px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    display: flex;
    align-items: center;
}

.page-back-img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    display: inline-block;
    position: relative;
    top: 2px;
}

.page-back {
    display: flex;
    align-items: center;
    margin-left: 30px;
    cursor: pointer;
}

.slider-container {
    width: 180px;
    height: calc(100vh - 136px);
    position: fixed;
    top: 118px;
}

.tree-container {
    width: 306px;
    height: 100vh;
}

.page-content {
    width: 1002px;
    margin-top: 100px;
    position: relative;
    left: 198px;
    padding-bottom: 18px;
}

.page-manage-content {
    width: 876px;
    padding-bottom: 18px;
    margin-left: 18px;
}

.page-content-item {
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    animation: animi 1s;
}
</style>
